export const UserData = [
    {
      id: 1,
      year: 'Mens',
      userGain: 800,
      userLost: 823,
    },
    {
      id: 2,
      year: 'Womens',
      userGain: 500,
      userLost: 345,
    },
    {
      id: 3,
      year: 'Kids',
      userGain: 300,
      userLost: 555,
    },
    {
      id: 4,
      year: 'Others',
      userGain: 850,
      userLost: 4555,
    },
    {
      id: 5,
      year: 'Accessories',
      userGain: 200,
      userLost: 234,
    },
  ];

  export const UserData2 = [
    {
      id: 1,
      year: 'Mens',
      userGain: 525,
      userLost: 823,
    },
    {
      id: 2,
      year: 'Womens',
      userGain: 562,
      userLost: 345,
    },
    {
      id: 3,
      year: 'Kids',
      userGain: 30,
      userLost: 555,
    },
    {
      id: 4,
      year: 'Others',
      userGain: 898,
      userLost: 4555,
    },
    {
      id: 5,
      year: 'Accessories',
      userGain: 350,
      userLost: 234,
    },
  ];